import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';

import { TSDListItem } from '@e-origin/contracts';
import { TSDType } from '@e-origin/shared';

import { AmendTSD } from './AmendTSD';
import { DuplicateTSD } from './DuplicateTSD';
import { NewTSD } from './NewTSD';
import { RevokePresentationNotification } from './RevokePresentationNotification';
import { SendPresentationNotification } from './SendPresentationNotification';

export const TSDModalManager = {
  openCreateTSD: (tsdView: TSDType) => {
    modals.open({
      title: 'New Temporary Storage',
      children: <NewTSD tsdView={tsdView} onHide={modals.closeAll} afterCreate={() => void 0} />,
      size: 'lg',
    });
  },
  openDeleteTSD: (tsdId: string, onConfirm: (tsdId: string) => void) => {
    modals.openConfirmModal({
      title: 'Delete Temporary Storage',
      children: <Text>Are you sure you want to delete this temporary storage? This action cannot be undone!</Text>,
      labels: { confirm: 'Delete', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: () => onConfirm(tsdId),
    });
  },
  openDuplicate: (tsd: TSDListItem) => {
    modals.open({
      title: 'Duplication',
      children: <DuplicateTSD tsd={tsd} onHide={modals.closeAll} />,
      size: 'lg',
    });
  },
  openSendPresentationNotification: (tsdId: string) => {
    modals.open({
      title: 'Send presentation notification',
      children: <SendPresentationNotification tsdId={tsdId} onHide={modals.closeAll} />,
      size: 'xl',
    });
  },
  openRevokePresentationNotification: (tsdId: string) => {
    modals.open({
      title: 'Revoke Presentation Notification',
      children: <RevokePresentationNotification tsdId={tsdId} onHide={modals.closeAll} />,
      size: 'lg',
    });
  },
  openAmend: (tsd: TSDListItem, onNavigate: () => void) => {
    modals.open({
      title: 'Amend Temporary Storage',
      children: <AmendTSD tsd={tsd} onHide={modals.closeAll} onNavigate={onNavigate} />,
      size: 'md',
      centered: true,
      withCloseButton: false,
    });
  },
};
